"use client";

import { Tabs, Tag } from 'antd';
import type { TabsProps } from 'antd';
import useMobileDetect from "@/hooks/useMobileDetect";
import {
  SearchOutlined
} from '@ant-design/icons';
import { CardList } from "./components/CardList";
import { useState, useEffect } from 'react';
import { useSearchParams, useRouter } from "next/navigation";
import Link from 'next/link';

import './style/index.css';

export enum CouponType {
  "REGISTER" = "REGISTER",
  "SHOP" = "SHOP",
}

type LabelType = {
  id: number,
  label: string,
}

export type CouponProps = {
  isMobile: boolean,
  tabList: ({
    children: LabelType[]
  } & LabelType)[],
  open?: boolean;
  type?: CouponType;
  onClose?: () => void;
};

export const ChannelTabs: React.FC<CouponProps> = ({
  isMobile = false,
  tabList,
  open = false,
  onClose,
  type = CouponType.SHOP,
  ...props
}) => {
  const searchParams = useSearchParams();
  const router = useRouter()
  // console.log('searchParams t1 : ', searchParams.get("t1"))
  // console.log('searchParams t2 : ', searchParams.get("t2"))

  // const router = useRouter();
  // console.log('router : ', JSON.stringify(router))
  // const { pid } = router.query;
  // const [activeKey, setActiveKey] = useState(tabList[0].id + '');
  // const [subActiveKey, setSubActiveKey] = useState(tabList[0].children[0].id + '');

  const [activeKey, setActiveKey] = useState("-1");
  const [subActiveKey, setSubActiveKey] = useState("-1");
  const [bodyWidth, setBodyWidth] = useState(0);

  const [hashParams, setHashParams] = useState<{ t1: string, t2: string } | null>(null);

  // const isMobile = useMobileDetect();

  useEffect(() => {
    if (!isMobile) {
      setBodyWidth(globalThis.document.body.clientWidth)
    }
    //
    const parseHashParams = () => {
      // 确保在客户端执行
      if (typeof window === 'undefined') return;

      const hash = window.location.hash.substring(1);
      const params = {};

      if (hash) {
        const pairs = hash.split('&');
        for (const pair of pairs) {
          const [key, value] = pair.split('=');
          if (key) {
            // @ts-ignore
            params[decodeURIComponent(key)] = decodeURIComponent(value || '');
          }
        }
      }
      // @ts-ignore
      setHashParams(params);
    };

    // 初始解析
    parseHashParams();

    // 监听hash变化
    const handleHashChange = () => {
      parseHashParams();
    };

    window.addEventListener('hashchange', handleHashChange);
    return () => {
      window.removeEventListener('hashchange', handleHashChange);
    };

  }, [isMobile])

  useEffect(() => {
    if (hashParams) {
      if (hashParams.t1) {
        setActiveKey(hashParams.t1)
      }
      if (hashParams.t2) {
        setSubActiveKey(hashParams.t2)
      }
    }
    console.log("hashParams: ", hashParams)
  }, [hashParams])

  const onChange = (key: string) => {
    console.log(key)
    setActiveKey(key)
    if (key === '-1') {
      setSubActiveKey("-1")
      // location.href = location.origin + '#'
      router.push(`#`)
    } else {
      const subId = tabList.find(item => item.id + '' === key)?.children[0].id + ''
      setSubActiveKey(subId)
      // location.href = location.origin + `#t1=${key}&t2=${subId}`
      router.push(`#t1=${key}&t2=${subId}`)
    }
  };

  const items: TabsProps['items'] = [{
    key: '-1',
    label: "For You",
    children: <CardList tagId={subActiveKey} isMobile={isMobile} />
  }, ...tabList.map(item => {
    const data = {
      key: item.id + '',
      label: item.label
    }

    if (item.children && item.children.length) {
      // @ts-ignore
      data.children = <div>
        {/* <div style={{ height: '4.6rem' }}></div> */}
        <div className="subCategoryWrap">
          <div
            key={item.id}
            className='itemsWrap'
          >
            {
              item.children.map(itemSub => <span
                onClick={() => {
                  setSubActiveKey(itemSub.id + '')
                  // location.href = location.origin + `#t1=${item.id}&t2=${itemSub.id}`
                  router.push(`#t1=${item.id}&t2=${itemSub.id}`)
                }}
                className={subActiveKey === itemSub.id + '' ? 'tag_category_active tag_category' : 'tag_category'}
                key={itemSub.id}
              >
                {itemSub.label}
              </span>)
            }
          </div>
        </div>
        <CardList tagId={subActiveKey} isMobile={isMobile} />
      </div>
    }

    return data
  })]

  return (<div className='cardList_race'>
    <div className="nav-bg"
      style={
        bodyWidth ? 
        { height: activeKey === "-1" ? '5.5rem' : '9.5rem', width: bodyWidth } 
        : { height: activeKey === "-1" ? '5.5rem' : '9.5rem' }
      }
    ></div>
    <Tabs
      // style={{marginTop: '4.8rem'}}
      activeKey={activeKey}
      items={items}
      onChange={onChange}
      tabBarExtraContent={isMobile ? <Link href="/search">
        <SearchOutlined style={{ color: 'rgba(255, 255, 255, 0.4)', fontSize: 17 }} />
        </Link>: null}
    />
  </div>)
}